import { Languages } from "lucide-react";

export const LANGS = [{ code: "en-US", label: "English" }, { code: "es-US", label: "Español" }, { code: "ht-HT", label: "Kreyòl" }];
export const langLabel = (c) => LANGS.find((l) => l.code === c)?.label || "English";
export const langFromPref = (s) => {
  const p = (s || "").toLowerCase();
  if (/^(es|span)/.test(p)) return "es-US";
  if (/^(ht|hait|creole|kreyol|kreyòl)/.test(p)) return "ht-HT";
  return "en-US";
};

const ES = {
  "Signing for": "Firmando por",
  "I don't want to sign now": "No quiero firmar ahora",
  "How would you like your records?": "¿Cómo desea recibir sus registros?",
  "Disclosure": "Aviso",
  "Sign and receive electronically": "Firmar y recibir electrónicamente",
  "Sign here, and I also want a paper copy": "Firmar aquí y también quiero una copia en papel",
  "Continue": "Continuar",
  "Document": "Documento",
  "of": "de",
  "Zoom out": "Alejar",
  "Zoom in": "Acercar",
  "Still needed": "Falta completar",
  "Start over": "Empezar de nuevo",
  "Start over?": "¿Empezar de nuevo?",
  "reset_body": "Esto borra sus firmas y respuestas para que pueda volver a llenarlas. Nada se ha enviado todavía.",
  "Clear this form": "Borrar este formulario",
  "Start all forms over": "Empezar todos los formularios de nuevo",
  "Keep my answers": "Conservar mis respuestas",
  "Back": "Atrás",
  "Review": "Revisar",
  "Next document": "Siguiente documento",
  "Final review": "Revisión final",
  "poa_title": "Firma del apoderado (POA)",
  "poa_optional": "Opcional: el apoderado puede firmar junto al paciente.",
  "Review / change": "Revisar / cambiar",
  "intent_1": "Yo,",
  "intent_rep": "({rel}, firmando por {patient})",
  "intent_2": "he revisado estos documentos y tengo la intención de firmarlos electrónicamente con",
  "Submitting...": "Enviando...",
  "Sign and submit": "Firmar y enviar",
  "Not signing right now?": "¿No va a firmar ahora?",
  "decline_body": "Está bien. El personal se comunicará con usted. Esto no decide su atención.",
  "I need more time / have questions": "Necesito más tiempo / tengo preguntas",
  "I'm unable to sign": "No puedo firmar",
  "I do not agree to sign": "No acepto firmar",
  "Apply": "Aplicar",
  "Tap to sign": "Toque para firmar",
  "Tap to initial": "Toque para poner iniciales",
  "Draw": "Dibujar",
  "Type instead": "Escribir",
  "Clear": "Borrar",
  "Captured": "Capturado",
  "sign_hint": "Use su dedo o lápiz para firmar",
  "initial_hint": "Use su dedo o lápiz para escribir sus iniciales",
  "Type your full name": "Escriba su nombre completo",
  "Your initials": "Sus iniciales",
  "retry_note": "no se perdió nada; puede intentarlo de nuevo.",
  "Before we begin": "Antes de comenzar",
  "confirm_details": "Confirme que estos datos son correctos.",
  "Patient": "Paciente",
  "Signing as": "Firmando como",
  "Provider organization": "Organización proveedora",
  "Yes, this is correct": "Sí, es correcto",
  "No, something is wrong": "No, algo está mal",
  "Please return the device": "Por favor devuelva el dispositivo",
  "Loading...": "Cargando...",
  "Preparing your documents.": "Preparando sus documentos.",
  "Thank you - staff will follow up": "Gracias - el personal se comunicará con usted",
  "Thank you - you're done": "Gracias - ha terminado",
  "rcpt_declined": "Se registró su decisión. No se firmó nada.",
  "rcpt_signed": "Sus documentos firmados se guardaron de forma segura.",
  "rcpt_review": "Su firma se guardó. El personal completará una revisión requerida antes de que los documentos sean finales.",
  "Receipt": "Recibo",
  "hand_back": "Por favor devuelva el dispositivo al miembro del personal.",
  "hand_back_help": "Gracias. Por favor devuelva el dispositivo al personal para que puedan ayudarle.",
  "Confirm your identity": "Confirme su identidad",
  "remote_intro": "le envió documentos para revisar. Ingrese los datos del paciente tal como están registrados.",
  "Patient last name": "Apellido del paciente",
  "Patient date of birth": "Fecha de nacimiento del paciente",
  "rep_last_name": "Si firma por otra persona: su apellido",
  "attempts_note": "Después de 3 intentos incorrectos este enlace se desactiva. Vence",
  "Download your signed copy": "Descargue su copia firmada",
  "You can close this page.": "Puede cerrar esta página.",
  "This link can't be used": "Este enlace no se puede usar",
  "Language": "Idioma",
  "Large text": "Texto grande",
  form_unavailable: "No hay una versión en {lang} de \"{form}\". Se muestra en {shown}.",
  lang_only: "Solo en {shown}",
  lang_missing_title: "No disponible en {lang}",
  lang_missing_body: "Estos formularios todavía no están disponibles en {lang}. Se mostrarán en otro idioma:",
  lang_missing_help: "Pida ayuda al personal o un intérprete si lo necesita.",
  "OK, continue": "Entendido, continuar",
};

const HT = {
  "Signing for": "N ap siyen pou",
  "I don't want to sign now": "Mwen pa vle siyen kounye a",
  "How would you like your records?": "Kijan ou vle resevwa dosye ou yo?",
  "Disclosure": "Avi",
  "Sign and receive electronically": "Siyen epi resevwa elektwonikman",
  "Sign here, and I also want a paper copy": "Siyen isit la, epi mwen vle yon kopi papye tou",
  "Continue": "Kontinye",
  "Document": "Dokiman",
  "of": "sou",
  "Zoom out": "Redwi",
  "Zoom in": "Agrandi",
  "Still needed": "Sa ki manke toujou",
  "Start over": "Rekòmanse",
  "Start over?": "Rekòmanse?",
  "reset_body": "Sa ap efase siyati ak repons ou yo pou ou ka ranpli yo ankò. Pa gen anyen ki voye deja.",
  "Clear this form": "Efase fòm sa a",
  "Start all forms over": "Rekòmanse tout fòm yo",
  "Keep my answers": "Kenbe repons mwen yo",
  "Back": "Retounen",
  "Review": "Revize",
  "Next document": "Pwochen dokiman",
  "Final review": "Dènye revizyon",
  "poa_title": "Siyati pwokirasyon (POA)",
  "poa_optional": "Opsyonèl: moun ki gen pwokirasyon an ka siyen akote pasyan an.",
  "Review / change": "Revize / chanje",
  "intent_1": "Mwen,",
  "intent_rep": "({rel}, k ap siyen pou {patient})",
  "intent_2": "revize dokiman sa yo epi mwen gen entansyon siyen yo elektwonikman avèk",
  "Submitting...": "N ap voye...",
  "Sign and submit": "Siyen epi voye",
  "Not signing right now?": "Ou pap siyen kounye a?",
  "decline_body": "Pa gen pwoblèm. Anplwaye yo ap kontakte w. Sa pa deside swen ou.",
  "I need more time / have questions": "Mwen bezwen plis tan / mwen gen kesyon",
  "I'm unable to sign": "Mwen pa kapab siyen",
  "I do not agree to sign": "Mwen pa dakò siyen",
  "Apply": "Aplike",
  "Tap to sign": "Tape pou siyen",
  "Tap to initial": "Tape pou mete inisyal",
  "Draw": "Desinen",
  "Type instead": "Ekri pito",
  "Clear": "Efase",
  "Captured": "Anrejistre",
  "sign_hint": "Sèvi ak dwèt ou oswa yon kreyon pou siyen",
  "initial_hint": "Sèvi ak dwèt ou oswa yon kreyon pou ekri inisyal ou",
  "Type your full name": "Ekri non konplè ou",
  "Your initials": "Inisyal ou",
  "retry_note": "anyen pa pèdi; ou ka eseye ankò.",
  "Before we begin": "Anvan nou kòmanse",
  "confirm_details": "Tanpri konfime enfòmasyon sa yo kòrèk.",
  "Patient": "Pasyan",
  "Signing as": "N ap siyen kòm",
  "Provider organization": "Òganizasyon swen an",
  "Yes, this is correct": "Wi, sa kòrèk",
  "No, something is wrong": "Non, gen yon bagay ki pa bon",
  "Please return the device": "Tanpri remèt aparèy la",
  "Loading...": "N ap chaje...",
  "Preparing your documents.": "N ap prepare dokiman ou yo.",
  "Thank you - staff will follow up": "Mèsi - anplwaye yo ap kontakte w",
  "Thank you - you're done": "Mèsi - ou fini",
  "rcpt_declined": "Nou anrejistre chwa ou. Anyen pa t siyen.",
  "rcpt_signed": "Dokiman ou siyen yo anrejistre an sekirite.",
  "rcpt_review": "Siyati ou anrejistre. Anplwaye yo ap fini yon revizyon obligatwa anvan dokiman yo final.",
  "Receipt": "Resi",
  "hand_back": "Tanpri remèt aparèy la bay anplwaye a.",
  "hand_back_help": "Mèsi. Tanpri remèt aparèy la bay anplwaye yo pou yo ka ede w.",
  "Confirm your identity": "Konfime idantite ou",
  "remote_intro": "voye dokiman pou ou revize. Antre enfòmasyon pasyan an egzakteman jan yo ye nan dosye a.",
  "Patient last name": "Siyati (non fanmi) pasyan an",
  "Patient date of birth": "Dat nesans pasyan an",
  "rep_last_name": "Si w ap siyen pou yon lòt moun: non fanmi ou",
  "attempts_note": "Apre 3 tantativ ki pa bon, lyen sa a ap bloke. Li ekspire",
  "Download your signed copy": "Telechaje kopi ou siyen an",
  "You can close this page.": "Ou ka fèmen paj sa a.",
  "This link can't be used": "Ou pa ka sèvi ak lyen sa a",
  "Language": "Lang",
  "Large text": "Tèks gwo",
  form_unavailable: "Pa gen vèsyon {lang} pou \"{form}\". Li parèt an {shown}.",
  lang_only: "{shown} sèlman",
  lang_missing_title: "Pa disponib an {lang}",
  lang_missing_body: "Fòm sa yo poko disponib an {lang}. Y ap parèt nan yon lòt lang:",
  lang_missing_help: "Tanpri mande anplwaye a èd oswa yon entèprèt si ou bezwen.",
  "OK, continue": "Dakò, kontinye",
};

const DICTS = { "es-US": ES, "ht-HT": HT };

export const makeT = (lang) => (key, vars) => {
  let s = DICTS[lang]?.[key] || EN[key] || key;
  Object.entries(vars || {}).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
  return s;
};

const EN = {
  poa_title: "Power of attorney signature",
  poa_optional: "Optional: the POA may sign next to the patient.",
  intent_1: "I,",
  intent_rep: "({rel}, signing for {patient})",
  intent_2: "have reviewed these documents and intend to sign them electronically with",
  decline_body: "That's okay. Staff will follow up with you. This does not decide your care.",
  reset_body: "This clears your signatures and answers so you can fill them in again. Nothing has been sent yet.",
  sign_hint: "Use your finger or stylus to sign",
  initial_hint: "Use your finger or stylus to write initials",
  retry_note: "nothing was lost; you can safely try again.",
  confirm_details: "Please confirm these details are correct.",
  rcpt_declined: "Your choice was recorded. Nothing was signed.",
  rcpt_signed: "Your signed documents were saved securely.",
  rcpt_review: "Your signature was saved. Staff will finish a required review before the documents are final.",
  hand_back: "Please hand the device back to the staff member.",
  hand_back_help: "Thank you. Please hand the device back to staff so they can help.",
  remote_intro: "sent you documents to review. Enter the patient's details exactly as on file.",
  rep_last_name: "If you sign for someone else: your last name",
  attempts_note: "After 3 incorrect attempts this link is disabled. Expires",
  form_unavailable: "No {lang} version of \"{form}\" is available. It is shown in {shown}.",
  lang_only: "{shown} only",
  lang_missing_title: "Not available in {lang}",
  lang_missing_body: "These forms have not been set up in {lang} yet. They will be shown in another language:",
  lang_missing_help: "Please ask the staff for help or an interpreter if you need one.",
  "OK, continue": "OK, continue",
};

export function LanguageBar({ lang, setLang, t, compact }) {
  return (
    <div className={`rounded-2xl border-2 border-sky-200 bg-sky-50/70 ${compact ? "p-3" : "p-4"} flex flex-wrap items-center gap-3`} data-testid="language-bar">
      <span className="flex items-center gap-2 text-base font-semibold text-slate-700 mr-auto"><Languages className="w-5 h-5 text-sky-700" />Language / Idioma / Lang</span>
      <div className="flex flex-wrap gap-2" role="group" aria-label={t ? t("Language") : "Language"}>
        {LANGS.map((l) => (
          <button key={l.code} onClick={() => setLang(l.code)} aria-pressed={lang === l.code} data-testid={`langbar-${l.code}`}
            className={`h-12 min-w-[110px] px-5 rounded-xl text-lg font-semibold border-2 transition-colors ${lang === l.code ? "bg-[#0B3D8C] border-[#0B3D8C] text-white" : "bg-white border-slate-200 text-slate-800 hover:border-sky-400"}`}>{l.label}</button>
        ))}
      </div>
    </div>
  );
}

export function LangToggle({ lang, setLang }) {
  return (
    <div className="flex shrink-0 rounded-lg border overflow-hidden" role="group" aria-label="Language / Idioma / Lang" data-testid="signing-language-toggle">
      {LANGS.map((l) => (
        <button key={l.code} onClick={() => setLang(l.code)} aria-pressed={lang === l.code} data-testid={`lang-${l.code}`}
          className={`px-3 h-12 text-sm font-medium ${lang === l.code ? "bg-slate-900 text-white" : "bg-white text-slate-700"}`}>{l.label}</button>
      ))}
    </div>
  );
}
